import type { AxiosInstance } from "axios";
import {
  EventIdPublic,
  EventParticipantIdPublic,
} from "@shared/schemas/branded-id.schemas";
import type { HostConnectionRequestsQuery } from "@shared/schemas/host-connection-requests.schemas";

export interface GetEventConnectionRequestsParams
  extends HostConnectionRequestsQuery {
  readonly eventIdPublic: EventIdPublic;
}

export function createConnectionRequestsApi(apiClient: AxiosInstance) {
  // Returns unknown: the response is validated by the repo hook's schema parse,
  // not here. An axios response generic would be an unchecked cast, not validation.
  async function getEventConnectionRequests(
    params: GetEventConnectionRequestsParams,
  ): Promise<unknown> {
    const response = await apiClient.get(
      `/api/v1/events/${encodeURIComponent(EventIdPublic.unwrap(params.eventIdPublic))}/connection-requests`,
      {
        params: {
          ...(params.page !== undefined && { page: params.page }),
          ...(params.limit !== undefined && { limit: params.limit }),
          // `direction` rides along with the participant it is relative to: the
          // API rejects one without the other.
          ...(params.participantIdPublic !== undefined && {
            participantIdPublic: EventParticipantIdPublic.unwrap(
              params.participantIdPublic,
            ),
            direction: params.direction,
          }),
          ...(params.vip !== undefined && { vip: params.vip }),
        },
      },
    );
    return response.data;
  }

  return { getEventConnectionRequests } as const;
}
